import styled from 'styled-components';
import { ChipStyleMixin } from 'shared/styles';

export const SettingsContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const SettingsListContainer = styled.div`
  box-shadow: 4px -3px 6px 1px #ebeff3a8;
  width: 20%;
  min-width: 282px;
  padding: 24px;
  z-index: 9;
  overflow: auto;
  background: white;
  .settings-item {
    font-size: 14px;
    line-height: 17px;
    color: #12344d;
    min-height: 44px;
    padding: 12px 16px;
    border-radius: 4px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: flex;
    transition: background 0.3s ease-out;

    min-height: 70px;
    padding: 15px 10px;
    border-radius: 4px;

    .settings-item-icon {
      margin-right: 12px;
      // display: none;
      img {
        width: 20px;
        min-width: 20px;
        height: 20px;
        fill: #12344d;
      }
    }
    .settings-item-text {
      color: #12344d;
      font-weight: 600;
      font-size: 14px;
    }
    .settings-item-description {
      font-weight: 400;
      color: #475867;
      font-size: 12px;
      white-space: break-spaces;
      padding-top: 5px;
      line-height: 1.5;
    }

    &.active {
      background: #f5f7f9;
      font-weight: 600;
    }
    :hover {
      cursor: pointer;
      background: #f5f7f9;
      .settings-item-text {
        color: var(--color-azure-800);
      }
    }
  }
`;

export const SettingsItemContainer = styled.div`
  background: white;
  display: flex;
  box-shadow: -4px 9px 6px 1px #ebeff3;
  border-left: 1px solid #ebeef0;
  overflow-y: auto;
  flex: 1;
  min-width: calc(80% - 282px);
`;

export const SettingsFixedDrawer = styled.div`
  width: 350px;
  z-index: 1;
  overflow: auto;
  background: #fff;
  border-left: 1px solid #ececec;
  padding: 34px;
  div.info-heading {
    margin-bottom: 16px;
    color: var(--base-color);
    font-weight: 600;
    font-size: 16px;
    line-height: 1.5;
  }
  div.info-name {
    margin-bottom: 8px;
    font-weight: 500;
    font-size: 14px;
    line-height: 17px;
    color: #183247;
  }
  div.info-description {
    margin-bottom: 16px;
    font-size: 12px;
    line-height: 22px;
    color: var(--color-smoke-700);
    text-align: left;
  }
`;

// No need below

export const Adornment = styled.div`
  padding-left: 12px;
  display: grid;
  place-content: center;
`;

export const CopyAdornment = styled.div`
  ${ChipStyleMixin}
  background: #ebeff3;
  border-radius: 4px;
  font-weight: 600;
  color: #384551;
  cursor: pointer;
`;

export const VerifyAdornment = styled.div`
  ${ChipStyleMixin}
  background: #e0f5f1;
  border-radius: 4px;
  font-weight: 600;
  color: #00795b;
  margin: 0 6px;
  cursor: pointer;
`;

export const SettingsForm = styled.form``;

const LabelTheme = {
  active: {
    color: '#007958',
    border: '#b4e5d9',
    background: '#E0F5F0',
  },
  pending: {
    color: '#C82124',
    border: '#FFD0D6',
    background: '#FFECF0',
  },
  inactive: {
    color: '#12344D',
    border: '#CFD7DF',
    background: '#fff',
  },
};

export const Label = styled.div`
  ${ChipStyleMixin}
  width: fit-content;
  font-weight: 600;
  align-items: center;
  color: ${(props: any) => LabelTheme[props.type].color};
  border: 1px solid ${(props: any) => LabelTheme[props.type].border};
  box-sizing: border-box;
  border-radius: 4px;
  text-align: center;
  min-width: 70px;
  background: ${(props: any) => LabelTheme[props.type].background};
`;
